
class Resources {
    APP_NAME = "";
    BACKEND_SIDE_BASE_URL ="https://dev2.mtlexpress.com.mm/crm-backend";//"http://localhost:8080/qq-delivery-backend";//
}

export default Resources;